import {GamesItem} from "../../items/games/GamesItem";
import {kGames} from "../../../constants/games";

export default function GamesList() {
    // Used in GamesScreenContent to display list of
    // local Games

    // BUILD
    return (
        <div className="w-full mt-[32px] grid gap-[16px] grid-cols-[repeat(auto-fit,minmax(200px,1fr))]">
            {kGames.map((game, index) => {
                return <GamesItem key={index}
                                  game={game} />
            })}
        </div>
    );
}